export default function CookieSettingsButton() {
  return (
    <button
      className="text-sm text-muted-foreground transition-colors hover:text-primary"
      onClick={() => window.dispatchEvent(new Event("justicedrive:open-cookie-settings"))}
      type="button"
    >
      Cookie settings
    </button>
  );
}
